module.exports = __webpack_public_path__ + "img/tiktok-monochrome.43803e5f.svg";